// import axios from 'axios';

// const API = process.env.REACT_APP_BACKEND_URL;

// const api = axios.create({
//   baseURL: `${API}/api`,
//   withCredentials: true,
// });

// // Public
// export const getServices = () => api.get('/services').then(r => r.data);
// export const getTestimonials = () => api.get('/testimonials').then(r => r.data);
// export const getTeam = () => api.get('/team').then(r => r.data);
// export const getPricing = () => api.get('/pricing').then(r => r.data);
// export const getClients = () => api.get('/clients').then(r => r.data);
// export const getBrochures = () => api.get('/brochures').then(r => r.data);
// export const submitContact = (data) => api.post('/contact', data).then(r => r.data);
// export const downloadBrochure = (id) => `${API}/api/brochures/download/${id}`;

// // Admin
// export const createService = (data) => api.post('/services', data).then(r => r.data);
// export const updateService = (id, data) => api.put(`/services/${id}`, data).then(r => r.data);
// export const deleteService = (id) => api.delete(`/services/${id}`).then(r => r.data);

// export const createTestimonial = (data) => api.post('/testimonials', data).then(r => r.data);
// export const updateTestimonial = (id, data) => api.put(`/testimonials/${id}`, data).then(r => r.data);
// export const deleteTestimonial = (id) => api.delete(`/testimonials/${id}`).then(r => r.data);

// export const createTeamMember = (data) => api.post('/team', data).then(r => r.data);
// export const updateTeamMember = (id, data) => api.put(`/team/${id}`, data).then(r => r.data);
// export const deleteTeamMember = (id) => api.delete(`/team/${id}`).then(r => r.data);

// export const createPricing = (data) => api.post('/pricing', data).then(r => r.data);
// export const updatePricing = (id, data) => api.put(`/pricing/${id}`, data).then(r => r.data);
// export const deletePricing = (id) => api.delete(`/pricing/${id}`).then(r => r.data);

// export const createClient = (data) => api.post('/clients', data).then(r => r.data);
// export const deleteClient = (id) => api.delete(`/clients/${id}`).then(r => r.data);

// export const uploadBrochure = (formData) => api.post('/brochures', formData, {
//   headers: { 'Content-Type': 'multipart/form-data' }
// }).then(r => r.data);
// export const deleteBrochure = (id) => api.delete(`/brochures/${id}`).then(r => r.data);

// export const getContacts = () => api.get('/contact').then(r => r.data);
// export const deleteContact = (id) => api.delete(`/contact/${id}`).then(r => r.data);



import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API}/api`,
  withCredentials: true,
});

// Add auth token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('a7_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public
export const getServices = () => api.get('/services').then(r => r.data);
export const getTestimonials = () => api.get('/testimonials').then(r => r.data);
export const getTeam = () => api.get('/team').then(r => r.data);
export const getPricing = () => api.get('/pricing').then(r => r.data);
export const getClients = () => api.get('/clients').then(r => r.data);
export const getBrochures = () => api.get('/brochures').then(r => r.data);
export const submitContact = (data) => api.post('/contact', data).then(r => r.data);
export const downloadBrochure = (id) => `${API}/api/brochures/download/${id}`;

// Admin
export const createService = (data) => api.post('/services', data).then(r => r.data);
export const updateService = (id, data) => api.put(`/services/${id}`, data).then(r => r.data);
export const deleteService = (id) => api.delete(`/services/${id}`).then(r => r.data);

export const createTestimonial = (data) => api.post('/testimonials', data).then(r => r.data);
export const updateTestimonial = (id, data) => api.put(`/testimonials/${id}`, data).then(r => r.data);
export const deleteTestimonial = (id) => api.delete(`/testimonials/${id}`).then(r => r.data);

export const createTeamMember = (data) => api.post('/team', data).then(r => r.data);
export const updateTeamMember = (id, data) => api.put(`/team/${id}`, data).then(r => r.data);
export const deleteTeamMember = (id) => api.delete(`/team/${id}`).then(r => r.data);

export const createPricing = (data) => api.post('/pricing', data).then(r => r.data);
export const updatePricing = (id, data) => api.put(`/pricing/${id}`, data).then(r => r.data);
export const deletePricing = (id) => api.delete(`/pricing/${id}`).then(r => r.data);

export const createClient = (data) => api.post('/clients', data).then(r => r.data);
export const deleteClient = (id) => api.delete(`/clients/${id}`).then(r => r.data);

export const uploadBrochure = (formData) => api.post('/brochures', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
}).then(r => r.data);
export const deleteBrochure = (id) => api.delete(`/brochures/${id}`).then(r => r.data);

export const getContacts = () => api.get('/contact').then(r => r.data);
export const deleteContact = (id) => api.delete(`/contact/${id}`).then(r => r.data);
